import React from 'react';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { withRouter, RouterProps, RouteComponentProps } from 'react-router';
import ControlledTable from '@components/ControlledTable';
import Paths from '@root/utils/Path';
import { RowInfo } from 'react-table';
import { Column } from 'react-virtualized';
import GraphQLClient from '@api/graphql/GraphQLClient';
import { Orders, OrderDirection } from '@api/graphql/types';
import * as Queries from '@api/graphql/queries';
import { DispatchProp, connect } from 'react-redux';
import { updateListOptions } from '@actions/listActions';
import { ListOptionType } from '@reducers/listReducer';
import { ApplicationState } from 'reducers/';

interface Props {
    id: string;
}

const UserOrderListDefaultOptions = {
    sortBy: {
        field: 'id',
        direction: OrderDirection.DESC,
    },
    count: 10,
    page: 0,
    filters: {
        id: '',
        user_id: '',
    },
};

const listName = 'userOrderList';

interface ReduxProps {
    listOptions: ListOptionType;
}

type PropType = Props & ReduxProps & DispatchProp & InjectedIntlProps & RouterProps & RouteComponentProps<{ id: string }>;

class UserOrderList extends React.Component<PropType> {

    public state = {
        data: [],
        paginatorInfo: {},
    };

    private tableColumns = [
        this.getDefaultColumnByName('id'),
        this.getDefaultColumnByName('created_at', {sortable: true}),
        this.getDefaultColumnByName('contact_data.contact_name'),
        this.getDefaultColumnByName('total_sum'),
        this.getDefaultColumnByName('status.code'),
        this.getDefaultColumnByName('shipping_method.name'),
    ];

    public componentDidMount() {
        this.fetchData();
    }

    public componentDidUpdate(prevProps: PropType) {
        if (prevProps.listOptions !== this.props.listOptions) {
            this.fetchData();
        }
    }

    private getDefaultColumnByName(name: string, options: any = {}) {
        return {
            Header: this.label(`${name}.title`),
            accessor: name,
            sortable: false,
            ...options,
        };
    }

    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.order.${id}` });
    }

    private getSortBy() {
        return {
            field: this.props.listOptions.sortBy.field.toUpperCase(),
            direction: this.props.listOptions.sortBy.direction.toUpperCase(),
        };
    }

    private fetchData() {
        const variables = {...this.props.listOptions, page: this.props.listOptions.page + 1, sortBy: this.getSortBy(), filters: {user_id: this.props.id}};
        GraphQLClient.query<Orders>({
            query: Queries.orders,
            variables,
        }).then(response => {
            const data = response.data.orders ? response.data.orders.data : [];
            const paginatorInfo = response.data.orders ? response.data.orders.paginatorInfo : {};
            this.setState({data, paginatorInfo});
        });
    }

    private onOptionsChange = (options: ListOptionType) => {
        this.props.dispatch(updateListOptions(`${listName}-${this.props.id}`, options));
    }

    private onRowClick = (finalState: any, rowInfo?: RowInfo, column?: Column, instance?: any): object | undefined => {
        if (rowInfo) {
            return {
                onClick: () => {
                    this.props.history.push(`${Paths.order}/${rowInfo.original.id}`);
                },
                style: {
                    cursor: 'pointer',
                },
            };
        }
        return {};
    }


    public render() {
        return (
            <ControlledTable
                listName={`${listName}-${this.props.id}`}
                defaultOptions={UserOrderListDefaultOptions}
                columns={this.tableColumns}
                options={this.props.listOptions}
                data={this.state.data}
                paginatorInfo={this.state.paginatorInfo}
                onOptionsChange={this.onOptionsChange}
                onRowClick={this.onRowClick}
            />
        );
    }
}

const mapStateToProps = ({ lists }: ApplicationState, props: PropType): ReduxProps => {
    const defaultOptions = {...UserOrderListDefaultOptions, filters: {user_id: props.id}};
    return { listOptions: (lists ? (lists[`${listName}-${props.id}`] || defaultOptions) : defaultOptions) };
};


export default compose(
    injectIntl,
    withRouter,
    connect(mapStateToProps),
)(UserOrderList);



// WEBPACK FOOTER //
// ./src/modules/User/components/UserOrderList.tsx